import React from 'react';
import { ListGroup } from 'reactstrap';
import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from './SortableItem';
import './style.css';

const SortableList = SortableContainer(({ items, onDelete }) => {
  if (items.length === 0) {
    return <div className="alert alert-info">Žádné položky!</div>;
  }
  return (
    <ListGroup>
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          onDelete={e => onDelete(index)}
        />
      ))}
    </ListGroup>
  );
});

export default SortableList;



// WEBPACK FOOTER //
// ./src/modules/Pricing/PriceList/SortableList.js